// extracted by mini-css-extract-plugin
export default {"pageLayout":"Layout_pageLayout__004LJ"};